import {Card} from "@/components/card/Card.tsx";
import {Divider} from "@/components/divider/Divider.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {PerformanceDataType} from "@/lib/types/checks.ts";
import {PublicProfileStats} from "@/lib/types/isitdown.ts";
import {CheckResponseTimeOverview} from "@/pages/checks/analysis/overview/CheckResponseTimeOverview.tsx";
import {getIntervalAlerts} from "@/pages/checks/analysis/overview/utils.ts";

import styles from "./PublicProfilesResponseTime.module.scss";

interface PublicProfilesResponseTimeProps {
  stats: PublicProfileStats;
  start: Date;
  end: Date;
}

export const PublicProfilesResponseTime = ({stats, start, end}: PublicProfilesResponseTimeProps) => {
  const intervalAlerts = getIntervalAlerts(stats.intervals!);

  return (
    <div className={styles.responseTimeSection}>
      <div className="marketingTextS2Bold pulse-color-gray-900 mb-4">Check Response Time</div>
      <Card variant="marketingWhite">
        <div className={styles.responseTimeCard}>
          <div className="pulseTextH2Bold pulse-color-gray-900 text-start">Service Response Time – Last 24 hours</div>
          <Divider className="mt-3 mb-2" />
          <UpErrorBoundary>
            <CheckResponseTimeOverview
              dataType={PerformanceDataType.RESPONSE_TIME}
              start={start}
              end={end}
              locations={stats.available_locations!}
              intervalAlerts={intervalAlerts}
              responseTimes={stats.location_response_times!}
              onRangeChange={() => {}}
              showTitle={false}
              showStatsInSubtitle={true}
              showMarkers={false}
              showPlotbandsInLegend
            />
          </UpErrorBoundary>
        </div>
      </Card>
    </div>
  );
};
